import React from "react";
import { useSubscription } from "@apollo/client";
import { TOP_GAINER } from "api/subscription/watchlist";
import Toast from "utils/Alert/Toast/Toast";
import WatchListLoader from "../../../../WatchList/common/WatchListLoader/WatchListLoader";
import TopStockWrapper from "../extra/TopStockWrapper/TopStockWrapper";
import { getError } from "utils/helpers";
import { ERROR } from "../../../../../constants";

const TopGainer = () => {
	const { loading, error, data } = useSubscription(TOP_GAINER);

	return (
		<>
			{error && (
				<Toast
					msg={getError(error)}
					variant={ERROR}
					toastId="top_gainer"
				/>
			)}
			<div className="mt-3 pb-3 accord">
				{loading ? (
					<WatchListLoader count={3} />
				) : (
					<ul className="bottom__border">
						{data?.top_gainers?.map((item) => (
							<TopStockWrapper item={item} />
						))}
					</ul>
				)}
			</div>
		</>
	);
};

export default TopGainer;
